import { AggregateDataCardProps } from '../AggregateDataCard'
import AggregateValuesPlot, {
  AggregateValuesPlotProps
} from './AggregateValuesPlot'

export interface AggregateDataListItemProps extends AggregateDataCardProps {
  logo: JSX.Element
  title: string
  label: string
  helperLabel: string
  aggregateValues?: AggregateValuesPlotProps['data']
}

export default function AggregateDataListItem(
  props: AggregateDataListItemProps
) {
  const {
    logo,
    title,
    label,
    subLabel,
    leftValue,
    valueLogo,
    valueText,
    rightValue,
    helperLabel,
    aggregateValues
  } = props
  return (
    <>
      <div
        className="p-4 rounded-xl inline-block w-full md:w-4/6"
        style={{ background: '#FBFAF9', border: '1px solid #E6E6E6E6' }}>
        <div
          className="bg-white rounded-xl flex flex-col lg:flex-row items-stretch"
          style={{ border: '1px solid #E6E6E6E6' }}>
          <div className="px-6 py-5 flex-1 flex flex-col justify-center">
            {/* Header section */}
            <div className="flex items-center gap-2 mb-5">
              <div className="h-5 w-5 flex items-center justify-center text-[#196E82]">
                {logo}
              </div>
              <p className="text-sm font-medium text-black">{title}</p>
            </div>

            {/* Content section */}
            <div className="flex flex-row items-start justify-between">
              <div className="flex-1">
                {/* Main stats */}
                <div className="flex flex-row items-center gap-4 flex-wrap mb-4">
                  <p
                    className="text-7xl font-semibold"
                    style={{ color: '#4A4340' }}>
                    {label}
                  </p>
                  <div>
                    <p
                      className="text-sm font-medium"
                      style={{ color: '#888581' }}>
                      {subLabel}
                    </p>
                    <div className="mt-2 flex flex-row gap-1 items-end flex-wrap">
                      <p
                        className="text-3xl leading-none"
                        style={{ color: '#4A4340' }}>
                        {leftValue}
                      </p>
                      {valueLogo && (
                        <div className="flex flex-col items-start gap-1">
                          <span className="flex-1 text-lg w-5 h-5">
                            {valueLogo}
                          </span>
                          {valueText && (
                            <p className="text-xs" style={{ color: '#4A4340' }}>
                              {valueText}
                            </p>
                          )}
                        </div>
                      )}
                      <p
                        className="text-3xl leading-none"
                        style={{ color: '#4A4340' }}>
                        {rightValue}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Helper text */}
                <p className="text-black opacity-60 text-xs max-w-md">
                  {helperLabel}
                </p>
              </div>
            </div>
          </div>

          {/* Data visualization section */}
          {aggregateValues && (
            <div className="flex items-center justify-center p-2 lg:p-4 lg:border-l border-t lg:border-t-0 border-[#E6E6E6]">
              <AggregateValuesPlot data={aggregateValues} />
            </div>
          )}
        </div>
      </div>
    </>
  )
}
